import { render, staticRenderFns } from "./Layout_DuelChallenge_Actions.vue?vue&type=template&id=191e5200&"
import script from "./Layout_DuelChallenge_Actions.vue?vue&type=script&lang=js&"
export * from "./Layout_DuelChallenge_Actions.vue?vue&type=script&lang=js&"
import style0 from "./Layout_DuelChallenge_Actions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports